<template>
  <v-navigation-drawer
    :value="value"
    @input="$emit('input', $event)"
    right
    temporary
    fixed
    app
    :width="drawerWidth"
    class="gpt-drawer"
  >
    <div class="d-flex flex-column fill-height">
      <div class="gpt-drawer__header d-flex align-center px-4 py-2">
        <img :src="gptLogo" alt="" class="gpt-drawer__logo mr-3" />
        <span class="gpt-drawer__title text-subtitle-1 font-weight-medium">Fero GPT</span>
        <span class="gpt-beta-badge ml-2">BETA</span>
        <v-spacer />
        <v-btn icon aria-label="Close Fero GPT" @click="$emit('input', false)">
          <v-icon color="#0E5E6D">mdi-close</v-icon>
        </v-btn>
      </div>
      <!-- Rendered only while open so closing destroys the iframe and a fresh session is created next time. -->
      <template v-if="value">
        <div
          v-if="error || !embedUrl"
          class="d-flex flex-column align-center justify-center text-center pa-6 flex-grow-1"
        >
          <v-icon size="64" color="error">mdi-alert-circle-outline</v-icon>
          <p class="mt-4 mb-0">{{ error || "Unable to start Fero GPT session." }}</p>
        </div>
        <!-- TODO: postMessage bridge to pass context to Fero GPT; validate the message origin when added. -->
        <iframe
          v-else
          :src="embedUrl"
          title="Fero GPT"
          referrerpolicy="strict-origin-when-cross-origin"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads"
          class="flex-grow-1"
          style="display: block; border: 0; width: 100%"
        />
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import gptLogo from "@/assets/images/fero-gpt.svg";

export default {
  name: "gpt-drawer",
  props: {
    value: { type: Boolean, default: false },
    // Contains a session token: never log it, render it as text, or send it to analytics.
    embedUrl: { type: String, default: "" },
    error: { type: String, default: "" },
  },
  data() {
    return { gptLogo, windowWidth: window.innerWidth };
  },
  computed: {
    drawerWidth() {
      return Math.min(1500, Math.floor(this.windowWidth * 0.9));
    },
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped>
.gpt-drawer__header {
  background: #fff;
  border-bottom: 2px solid #17b7d0;
}
.gpt-drawer__logo {
  height: 24px;
}
.gpt-drawer__title {
  color: #0e5e6d;
}
.gpt-beta-badge {
  background: #17b7d0;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1;
  padding: 4px 7px;
  border-radius: 8px;
}
</style>
